import React, { useEffect, useState } from 'react';
import { styled, makeStyles } from '@mui/styles';
import { Checkbox, Grid2, TableCell, TableRow, Tooltip } from '@mui/material';
import theme from '../../../core/theme';
import moment from 'moment';
import { ContentResponse } from '../../../data/types/content.interface';
import { last } from 'lodash';
import unused from '../../../assets/images/unused.png';
import used from '../../../assets/images/used.png';
import notInUse from '../../../assets/images/notInUse.png';
import { TagType } from '../../../data/types/tags.interface';

const useStyles = makeStyles({
  hover: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  overflow: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '90%',
  },
  themeButtons: {
    width: '60px',
    height: '25px',
    display: 'flex',
    padding: '2px 0',
    justifyContent: 'center',
    borderRadius: '12px',
    alignItems: 'center',
    '&.travel': {
      border: '1px solid #C0F3C6',
      backgroundColor: '#E6FFE9',
      color: '#238E30',
    },
    '&.fun': {
      border: '1px solid #FCE68A',
      backgroundColor: '#FDF3C7',
      color: '#DD851C',
    },
    '&.learn': {
      border: '1px solid #BFDBFE',
      backgroundColor: '#DBEAFE',
      color: '#2863EB',
    },
  },
});

interface Props {
  index: number;
  content: ContentResponse;
  isChecked?: boolean;
  onRowClicked: () => void;
  onCheck: (isChecked: boolean) => void;
  isAdminOrCreativeEditor?: boolean;
}

const StyledTableCell: any = styled(TableCell)(() => ({
  paddingTop: '12px',
  paddingBottom: '12px',
  borderBottom: `1px solid ${theme.palette.chipBg.main}`,
}));

const ContentRow: React.FC<Props> = ({ content, isChecked, onRowClicked, onCheck, isAdminOrCreativeEditor }) => {
  const classes = useStyles();
  const [checked, setChecked] = useState<boolean>(false);

  const theme = content.theme || content?.themes?.find((t: TagType) => t.type === 'theme')?.name;

  const handleSelectedRow = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  useEffect(() => {
    onCheck(checked);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checked]);

  return (
    <>
      <TableRow key={content.id}>
        <StyledTableCell component="td" style={{ width: '3%', padding: 0 }}>
          <Checkbox
            size="small"
            sx={{
              paddingTop: '0px',
              paddingBottom: '0px',
              marginBottom: '2px',
              color: isChecked ? '#303340 !important' : '#E1E3E8 !important',
            }}
            checked={isChecked || false}
            disabled={!isAdminOrCreativeEditor}
            onChange={handleSelectedRow}
          />
        </StyledTableCell>
        <StyledTableCell
          component="td"
          style={{ width: '20%' }}
          role="button"
          className={classes.hover}
          onClick={onRowClicked}
        >
          <Tooltip title={content.filename}>
            <div className={classes.overflow}>{content.filename}</div>
          </Tooltip>
        </StyledTableCell>
        <StyledTableCell
          component="td"
          style={{ width: '10%' }}
          role="button"
          className={classes.hover}
          onClick={onRowClicked}
        >
          <div>{moment(content.lastUpdatedAt).format('YYYY-MM-DD')}</div>
        </StyledTableCell>
        <StyledTableCell
          component="td"
          style={{ width: '10%' }}
          role="button"
          className={classes.hover}
          onClick={onRowClicked}
        >
          <div className={`${classes.themeButtons} ${theme === 'Travel' ? 'travel' : theme === 'Fun' ? 'fun' : 'learn'}`} >
            {theme || ''}
          </div>
        </StyledTableCell>
        <StyledTableCell
          component="td"
          style={{ width: '10%' }}
          role="button"
          className={classes.hover}
          onClick={onRowClicked}
        >
          <div className={classes.overflow}>{content.category || ''}</div>
        </StyledTableCell>
        <StyledTableCell
          component="td"
          style={{ width: '15%' }}
          role="button"
          className={classes.hover}
          onClick={onRowClicked}
        >
          <div className={classes.overflow}>{content.subCategory || ''}</div>
        </StyledTableCell>
        <StyledTableCell component="td" style={{ width: '120px' }} className={classes.hover} onClick={onRowClicked}>
          <div className={classes.overflow}>{last(content.pathLink.split('/')) || ''}</div>
        </StyledTableCell>
        <StyledTableCell
          component="td"
          style={{ width: '15%' }}
          role="button"
          className={classes.hover}
          onClick={onRowClicked}
        >
          <div className={classes.overflow}>{content.title}</div>
        </StyledTableCell>
        <StyledTableCell component="td" style={{ width: '7%' }}>
          <Grid2 container direction="row">
            <span>
              <img
                src={content?.edited === 'NotInUse' ? notInUse : content?.edited === 'Unused' ? unused : used}
                alt="Preview"
              />
            </span>
          </Grid2>
        </StyledTableCell>
      </TableRow>
    </>
  );
};

export default ContentRow;
